module.exports = __webpack_public_path__ + "static/img/empty.28506d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/img/empty.jpg
// module id = F23X
// module chunks = 1